var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#696D8C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 0.666687C12.0501 0.666687 15.3334 3.94993 15.3334 8.00002C15.3334 12.0501 12.0501 15.3334 8.00002 15.3334C3.94993 15.3334 0.666687 12.0501 0.666687 8.00002C0.666687 3.94993 3.94993 0.666687 8.00002 0.666687ZM8.00002 2.00002C4.68631 2.00002 2.00002 4.68631 2.00002 8.00002C2.00002 11.3137 4.68631 14 8.00002 14C11.3137 14 14 11.3137 14 8.00002C14 4.68631 11.3137 2.00002 8.00002 2.00002ZM8.00002 3.33335C8.36821 3.33335 8.66669 3.63183 8.66669 4.00002V7.67396L11.4093 9.80712C11.6999 10.0332 11.7523 10.452 11.5263 10.7426C11.3002 11.0333 10.8814 11.0856 10.5907 10.8596L7.59073 8.52626C7.42834 8.39995 7.33335 8.20575 7.33335 8.00002V4.00002C7.33335 3.63183 7.63183 3.33335 8.00002 3.33335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.8100060fb12250039bc17a35c41ba195.svg";
export { ForwardRef as ReactComponent };